/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_HU_HU: Record<string, string> = {
    ariaAnnounceChart: 'diagram, ${seriesCount}[number] sorozat',
    ariaAnnounceFlowProportionLink:
        'hivatkozás ${index} a(z) ${count} közül, ${from}-tól ${to}-ig, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: '${count} közül ${index} csomópont, ${description}',
    ariaAnnounceGaugeChart: 'mérőműszer diagram, ${caption}',
    ariaAnnounceHierarchyChart: 'hierarchia diagram, ${caption}',
    ariaAnnounceHierarchyDatum: 'szint ${level}[number], ${count}[number] gyermek, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Nyomja meg a Szóközt vagy az Entert a láthatóság váltásához',
    ariaLabelAddHorizontalLine: 'Vízszintes vonal hozzáadása',
    ariaLabelAnnotationOptionsToolbar: 'Jelölési lehetőségek',
    ariaLabelAnnotationSettingsDialog: 'Jelölés beállításai',
    ariaLabelColorPicker: 'Színválasztó',
    ariaLabelFinancialCharts: 'Pénzügyi diagramok',
    ariaLabelLegend: 'Jelmagyarázat',
    ariaLabelLegendItem: '${label}, Jelmagyarázat eleme ${index}-ből [number] ${count}-ből [number]',
    ariaLabelLegendItemUnknown: 'Ismeretlen jelmagyarázati elem',
    ariaLabelLegendPageNext: 'Következő jelmagyarázat oldal',
    ariaLabelLegendPagePrevious: 'Előző jelmagyarázat oldal',
    ariaLabelLegendPagination: 'Jelmagyarázat Lapozás',
    ariaLabelNavigator: 'Navigátor',
    ariaLabelNavigatorMaximum: 'Maximum',
    ariaLabelNavigatorMinimum: 'Minimum',
    ariaLabelNavigatorRange: 'Tartomány',
    ariaLabelRangesToolbar: 'Tartományok',
    ariaLabelSettingsTabBar: 'Beállítások',
    ariaLabelZoomToolbar: 'Nagyítás',
    ariaValuePanRange: '${min}[percent0to2dp] és ${max}[percent0to2dp] között',
    contextMenuDownload: 'Letöltés',
    contextMenuPanToCursor: 'Pásztázás ide',
    contextMenuToggleOtherSeries: 'További sorozatok megjelenítése/elrejtése',
    contextMenuToggleSeriesVisibility: 'Láthatóság váltása',
    contextMenuZoomToCursor: 'Nagyítás ide',
    dialogHeaderChannel: 'Csatorna',
    dialogHeaderDatePriceRange: 'Dátum és ár',
    dialogHeaderDateRange: 'Dátum tartomány',
    dialogHeaderFibonacciRange: 'Fibonacci visszahúzódás',
    dialogHeaderLine: 'Vonal',
    dialogHeaderPriceRange: 'Ártartomány',
    dialogHeaderText: 'Szöveg',
    dialogInputAlign: 'Igazítás',
    dialogInputColorPicker: 'Szín',
    dialogInputColorPickerAltText: 'Szövegszín',
    dialogInputExtendAbove: 'Kiterjesztés fölé',
    dialogInputExtendBelow: 'Kiterjesztés alá',
    dialogInputExtendChannelEnd: 'Csatorna végének kiterjesztése',
    dialogInputExtendChannelStart: 'Csatornakezdés kiterjesztése',
    dialogInputExtendLeft: 'Balra kiterjesztés',
    dialogInputExtendLineEnd: 'Vonalvég meghosszabbítása',
    dialogInputExtendLineStart: 'Vonal kezdésének kiterjesztése',
    dialogInputExtendRight: 'Nyújtás jobbra',
    dialogInputFibonacciBands: 'Sávok',
    dialogInputFibonacciBandsAltText: 'Fibonacci sávok',
    dialogInputFillColorPicker: 'Kitöltés',
    dialogInputFillColorPickerAltText: 'Kitöltési szín',
    dialogInputFontSize: 'Méret',
    dialogInputFontSizeAltText: 'Betűméret',
    dialogInputLineStyle: 'Szaggatott',
    dialogInputPosition: 'Pozíció',
    dialogInputReverse: 'Fordított',
    dialogInputShowFill: 'Kitöltés megjelenítése',
    dialogInputStrokeWidth: 'Súly',
    dialogInputStrokeWidthAltText: 'Vonal súly',
    iconAltTextAlignCenter: 'Középre',
    iconAltTextAlignLeft: 'Balra',
    iconAltTextAlignRight: 'Jobbra',
    iconAltTextClose: 'Bezárás',
    iconAltTextLineStyleDashed: 'Hosszú szaggatott',
    iconAltTextLineStyleDotted: 'Rövid szaggatott',
    iconAltTextLineStyleSolid: 'Folyamatos',
    iconAltTextPositionBottom: 'Alsó',
    iconAltTextPositionCenter: 'Középre',
    iconAltTextPositionTop: 'Felül',
    inputTextareaPlaceholder: 'Adjon hozzá szöveget',
    measurerDateRangeBars: '${value}[number] oszlopok',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Térfogat ${value}',
    overlayLoadingData: 'Adatok betöltése...',
    overlayNoData: 'Nincs megjeleníthető adat',
    overlayNoVisibleSeries: 'Nincs látható sorozat',
    overlayUnsupportedBrowser: 'Nem kompatibilis böngészőverzió. Kérjük, frissítse böngészőjét.',
    seriesHistogramTooltipCount: '${yName} (darab)',
    seriesHistogramTooltipFrequency: 'Gyakoriság',
    seriesHistogramTooltipMean: '${yName} (átlag)',
    seriesHistogramTooltipSum: '${yName} (összeg)',
    toolbarAnnotationsArrow: 'Nyíl',
    toolbarAnnotationsArrowDown: 'Nyíl lefelé',
    toolbarAnnotationsArrowUp: 'Fel nyíl',
    toolbarAnnotationsCallout: 'Kihívás',
    toolbarAnnotationsClearAll: 'Összes törlése',
    toolbarAnnotationsComment: 'Megjegyzés',
    toolbarAnnotationsDatePriceRange: 'Dátum és Ár',
    toolbarAnnotationsDateRange: 'Dátumtartomány',
    toolbarAnnotationsDelete: 'Törlés',
    toolbarAnnotationsDisjointChannel: 'Széttartó Csatorna',
    toolbarAnnotationsDragHandle: 'Eszköztár húzása',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fibo visszahúzódás',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Trend alapú Fibonacci',
    toolbarAnnotationsFillColor: 'Kitöltési Szín',
    toolbarAnnotationsHorizontalLine: 'Vízszintes vonal',
    toolbarAnnotationsLineAnnotations: 'Trendvonalak',
    toolbarAnnotationsLineColor: 'Vonal színe',
    toolbarAnnotationsLineStrokeWidth: 'Vonal vastagsága',
    toolbarAnnotationsLineStyle: 'Vonalstílus',
    toolbarAnnotationsLock: 'Zárolás',
    toolbarAnnotationsMeasurerAnnotations: 'Mérők',
    toolbarAnnotationsNote: 'Megjegyzés',
    toolbarAnnotationsParallelChannel: 'Párhuzamos csatorna',
    toolbarAnnotationsPriceRange: 'Ártartomány',
    toolbarAnnotationsQuickDatePriceRange: 'Mérték',
    toolbarAnnotationsSettings: 'Beállítások',
    toolbarAnnotationsShapeAnnotations: 'Nyilak',
    toolbarAnnotationsText: 'Szöveg',
    toolbarAnnotationsTextAnnotations: 'Szöveges annotációk',
    toolbarAnnotationsTextColor: 'Szöveg színe',
    toolbarAnnotationsTextSize: 'Szöveg Méret',
    toolbarAnnotationsTrendLine: 'Trendvonal',
    toolbarAnnotationsUnlock: 'Feloldás',
    toolbarAnnotationsVerticalLine: 'Függőleges vonal',
    toolbarRange1Month: '1H',
    toolbarRange1MonthAria: '1 hónap',
    toolbarRange1Year: '1 Év',
    toolbarRange1YearAria: '1 év',
    toolbarRange3Months: '3H',
    toolbarRange3MonthsAria: '3 hónap',
    toolbarRange6Months: '6 hó',
    toolbarRange6MonthsAria: '6 hónap',
    toolbarRangeAll: 'Összes',
    toolbarRangeAllAria: 'Összes',
    toolbarRangeYearToDate: 'Év elejétől',
    toolbarRangeYearToDateAria: 'Év elejétől',
    toolbarSeriesTypeCandles: 'Gyertyák',
    toolbarSeriesTypeDropdown: 'Diagramtípus',
    toolbarSeriesTypeHighLow: 'Magas Alacsony',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Üreges gyertyák',
    toolbarSeriesTypeLine: 'Vonal',
    toolbarSeriesTypeLineWithMarkers: 'Vonal jelölőkkel',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Lépcsős vonal',
    toolbarZoomPanEnd: 'Görgetés a végére',
    toolbarZoomPanLeft: 'Balra mozgatás',
    toolbarZoomPanRight: 'Jobbra gördítés',
    toolbarZoomPanStart: 'Lapozás az elejére',
    toolbarZoomReset: 'Nagyítás visszaállítása',
    toolbarZoomZoomIn: 'Nagyítás',
    toolbarZoomZoomOut: 'Kicsinyítés',
    tooltipPaginationStatus: '${index}[number] a(z) ${count}[number]',
};
